import { useEffect } from 'react';
import { useAppDispatch } from '../store';
import { tokenInterceptor } from '../common/utils/tokenInterceptor';

// Hook to initialize token interceptor with Redux dispatch
export const useTokenInterceptor = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    // Set up the token interceptor with Redux dispatch
    tokenInterceptor.setDispatch(dispatch);
    
    // Start periodic token validation (every 5 minutes)
    tokenInterceptor.startTokenValidation(5 * 60 * 1000);
    
    // Cleanup on unmount
    return () => {
      tokenInterceptor.setDispatch(undefined);
    };
  }, [dispatch]);
};
